module.exports = "/assets/77eb2db1068e43d0a1a355dbab9e5333.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WC.png
// module id = 1955
// module chunks = 0